module.exports = __webpack_public_path__ + "img/cooperation_unit_09.b53be692.png";